module.exports = __webpack_public_path__ + "static/img/rock_card@2x.1e8ce79c.png";